import React from "react";
import { SkeletonBar } from "../../../components/Skeleton/Skeleton"; // pulls in the .cd-skl shimmer styles
import "../../DataEntryOperator/Goals/Goals.css";
import "./MasterCompanyMaster.css";

/* Shimmer grid shaped like the Company Master module cards
   (gp-card: icon+name head, metric rows, coloured action strip).
   Shared by the Company Master, Business Accreditation and
   Branches card lists so the initial-load placeholder matches
   whatever card each tab renders. */
type Props = {
    count?: number;   // number of shimmer cards
    rows?: number;    // metric rows per card
    actions?: number; // action-strip buttons per card
    withStatus?: boolean; // reserve a status-pill block in the head
    solo?: boolean;   // single half-width card (Company Master hub) instead of the 3-col grid
};

const MasterCardSkeleton = ({ count = 6, rows = 3, actions = 2, withStatus = true, solo = false }: Props) => (
    <div className={solo ? "gp-solo" : "gp-cards"}>
        {Array.from({ length: solo ? 1 : count }).map((_, i) => (
            <div className="gp-skl-card" key={i}>
                <div className="gp-chead">
                    <span className="cd-skl" style={{ width: 34, height: 34, borderRadius: 10 }} />
                    <span className="cd-skl" style={{ flex: 1, height: 14, borderRadius: 6 }} />
                    {withStatus && <span className="cd-skl" style={{ width: 62, height: 20, borderRadius: 999 }} />}
                </div>
                <div className="gp-body">
                    <div className="gp-metrics">
                        {Array.from({ length: rows }).map((_, j) => (
                            <div className="gp-metric" key={j}>
                                <SkeletonBar w={92 + (j % 3) * 20} h={11} />
                                <SkeletonBar w={74} h={12} />
                            </div>
                        ))}
                    </div>
                </div>
                <div className="gp-acts">
                    {Array.from({ length: actions }).map((_, k) => (
                        <span className="cd-skl" key={k} style={{ flex: 1, height: 34, borderRadius: 9 }} />
                    ))}
                </div>
            </div>
        ))}
    </div>
);

export default MasterCardSkeleton;
